import { GetBillResponseData } from '@features/bills/query-api'
import { Bill } from '@features/bills/types/bill'
import { Contact } from '@features/contacts/types/contact'

export const getBillQueryData = (
  billId: string,
  bills: Bill[],
  contacts: Contact[],
): GetBillResponseData | undefined => {
  const bill = bills.find(({ id }) => id === billId)

  if (bill) {
    const billContacts = contacts.filter(({ id }) => id === bill?.contactId)

    return {
      bill,
      billLines: bill?.lines || [],
      ...(billContacts.length ? { contacts: billContacts } : {}),
    }
  }

  return undefined
}
